module.exports = __webpack_public_path__ + "components/developers/img-portret/IgorVasylytsya.jpg";